import { Button, Checkbox, Image } from "grabcad-ui-elements";
import styled from "styled-components";

// Style for Company
export const CompanyDropdownContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px; /* Spacing between each radio button */
`;

export const FormContainer = styled.div`
    display: flex;
    align-items: flex-start; /* Align items on the left */
    gap: 20px; /* Spacing between the form field and the radio buttons */
    margin-bottom: 10px;
`;

export const FormFieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const DropdownLabel = styled.label`
    min-width: 120px; /* Minimum width to align label with radio buttons */
    font-weight: bold;
    margin-right: 10px; /* Spacing between label and radio buttons */
`;

export const DropdownStyle = styled.div`
    display: flex;
    gap: 20px;
`;

// Style for CompanyList
export const TOSHeader = styled.th`
    width: 10%;
`;

export const Container = styled.div`
    margin-top: 1rem;
`;

export const DropdownContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-left: 1rem;
`;

export const StyledInput = styled.input`
    flex: 1;
    margin-right: 1rem;
    margin-top: 2rem !important;
`;

export const StyledButton = styled(Button)`
    margin-top: 2rem !important;
`;

export const SearchContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
`;

export const SearchIcon = styled.i`
    margin-top: 1rem !important;
`;

export const StyledCheckbox = styled(Checkbox)`
    margin-left: 1rem;
    margin-top: 2rem;
`;
// Also Used in StaleCompanies
export const HighlightRow = styled.tr`
    &:hover {
        background-color: #deeeff;
    }
`;
// Style for CompanyAccessOptionTable
export const Icon = styled(Image)`
    display: inline !important;
    margin-right: 5px;
    height: 1.35em;
    width: 1.35em;

    :hover {
        height: 1.55em;
    }
`;
// Also Used in StaleCompanies
export const HighlightEntry = styled.td`
    cursor: pointer;
    &:hover {
        text-decoration: underline;
        color: #4183c4;
    }
`;

// Style for StaleCompanies
export const MonthsInput = styled.input`
    width: 48px;
`;

export const HardDeleteOption = styled(Checkbox)`
    margin-top: 12px;
    display: inline-block;
`;
